'use strict';

module.exports = function (ngModule) {
    ngModule.directive('iocAttribute', require('./iocattribute'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/iocattribute/index.js
 **/